<button type="button" class="class-card" [ngClass]="{ 'class-card--archived': isArchived() }" (click)="handleClick()">
  <div class="relative h-20 w-full shrink-0">
    <dojo-class-background [color]="backgroundColor()" size="small" />

    @if (isArchived()) {
      <div class="absolute right-3 top-3 rounded-md bg-neutral-100 px-2 py-1 text-neutral-600">
        <span class="text-xs font-semibold">Archived</span>
      </div>
    }
  </div>

  <div class="class-card__content">
    <div
      class="border-neutral-0 relative flex size-[88px] items-center justify-center rounded-full border-4"
      [ngClass]="badgeColorClass()"
    >
      <span class="text-[56px] leading-none" [ngClass]="{ grayscale: isArchived() }">{{
        classData().emoji || '📚'
      }}</span>
    </div>

    <div class="flex flex-1 flex-col justify-between gap-6">
      <div class="flex flex-col">
        <h3 class="text-primary mb-0.5 text-lg font-semibold">{{ classData().name }}</h3>

        @if (resolvedSchoolName()) {
          <p class="text-primary text-md">{{ resolvedSchoolName() }}</p>
        }
      </div>

      <div class="mt-auto flex h-5 items-center justify-between">
        <span class="text-secondary adjusted-numbers text-sm">
          {{ classData().course_name || classData().syllabus_name }}
        </span>

        <div class="flex items-center gap-1">
          <dojo-icon [icon]="'user-group'" [size]="16" class="text-secondary" />
          <span class="text-secondary adjusted-numbers text-sm">
            {{ classData().student_count || 0 }}
          </span>
        </div>
      </div>
    </div>
  </div>
</button>
